import script from "./SubsidiaryChangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubsidiaryChangeView.vue?vue&type=script&setup=true&lang=js"

import "./SubsidiaryChangeView.vue?vue&type=style&index=0&id=7d664ce9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d664ce9"]])

export default __exports__